/* eslint-disable prettier/prettier */

import { UnorderedListProps, ListItemProps } from "@twilio-paste/core/list";
import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const formStyles: BoxStyleProps = {
    padding: "space40",
    paddingTop: "space80",
    overflow: "auto",
    backgroundColor: "colorBackground",
    height: "100%"
};

/*
 * export const titleStyles: TextStyleProps = {
 *     fontSize: "fontSize70",
 *     marginBottom: "space60",
 *     color: "colorTextWeak",
 *     lineHeight: "lineHeight50"
 * };
 */

export const introStyles: TextStyleProps = {
    marginBottom: "space70",
    color: "colorTextWeak"
};

export const fieldStyles: BoxStyleProps = {
    marginBottom: "space70",
    color: "colorTextWeak"
};


export const buttonStyles: BoxStyleProps = {
    marginX: "auto",
    backgroundColor: "colorBackgroundPrimary",
    color: "colorTextLink",
    padding: "space40",
    borderColor: "colorBorderPrimary",
    boxShadow: "none",
    borderRadius: "borderRadius20",
    _hover: {
        backgroundColor: "colorBackgroundPrimaryWeak",
        borderColor: "colorBorderPrimaryWeak",
        boxShadow: "none"
    }
};

export const scheduleBoxStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    marginTop: "space60"
};

export const scheduleItemStyles: ListItemProps = {
    css: {
        marginTop: "space0",
        marginBottom: "space0"
    }
};

export const scheduleListStyles: UnorderedListProps = {
    marginTop: "space10",
    marginBottom: "space0"
};
export const boxContainerStyles: BoxStyleProps = {
    width: "100%",
    display: "flex",
    justifyContent: "center"
};
